module.exports = __webpack_public_path__ + "static/media/Introduksjon-sprakforstaelse.5dde5745.mp3";